import { ContrastGraphQLFieldConfig } from '..'
import { Context } from '../shared'
import {
  GenericMutationResponse,
  GenericMutationResponseType
} from '../types/generic-mutation-response'
import {
  GraphQLNonNull,
  GraphQLInputObjectType,
  GraphQLID,
  GraphQLString
} from 'graphql'

export const deleteAttackEventTag: ContrastGraphQLFieldConfig<
  any,
  Context,
  {
    readonly input?: {
      readonly organizationID: string
      readonly eventUuid: string
      readonly tag: string
    }
  },
  GenericMutationResponse
> = {
  description: 'Delete a tag from an attack event',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: {
    input: {
      type: new GraphQLInputObjectType({
        name: 'AttackEventTagDeleteMutationArgs',
        description:
          'Parameters that describe a delete operation for an attack event tag',
        fields: () => ({
          organizationID: {
            description: 'The ID of the organization of the tag being deleted',
            type: new GraphQLNonNull(GraphQLID)
          },
          eventUuid: {
            type: new GraphQLNonNull(GraphQLID)
          },
          tag: {
            type: new GraphQLNonNull(GraphQLString)
          }
        })
      })
    }
  },
  resolve: async (
    _source,
    args,
    context: Context
  ): Promise<GenericMutationResponse> => {
    const { input } = args

    if (!input) {
      throw new Error('mutation input parameter is required')
    }

    const { organizationID, eventUuid, tag } = input

    const { connector } = context

    await connector.executeDelete(
      `/${organizationID}/tags/attack/event/${eventUuid}`,
      {
        tag
      }
    )

    return { _placeholder: true }
  }
}
